module.exports = __webpack_public_path__ + "img/白堽乡.bd4bfa95.png";